
<div class="container" *ngIf="isModifiable">
  <button class="generic-button inputPlusMoins" (click)="manqueComposant(-1)">-</button>
  <input type="text" class="inputManqueReception" [ngClass]="{'rouge': this.composant.quantiteLivreeRelative != 0}" [attr.value]="formattedQuantiteLivreeRelative" disabled="disabled">
  <button class="generic-button inputPlusMoins" (click)="manqueComposant(1)">+</button>
</div>
<div class="container" *ngIf="!isModifiable">
  <div class="affichage-non-modifiable" [ngClass]="{'rouge': this.composant.quantiteLivreeRelative != 0}">{{ formattedQuantiteLivreeRelative }}</div>
</div>
